export const footerText = '© Powered by Dangnh';
